/**
 * Which experiments are being compared, and how each is drawn. The ids live in
 * the URL (`/compare?ids=a,b,c`, and `?select=a,b` on the lists that lead
 * there), so a comparison is a link that can be pasted into a discussion.
 */

import type { ExperimentSummary } from "@/features/experiments/types";

export const MIN_COMPARE = 2;
export const MAX_COMPARE = 5;

/** Shared CSS series tokens keep chart dots, legends and table headings in sync.
 * The dark palette follows the UX Revamp PDF; blue/orange remain metric deltas. */
export const SERIES_COLOURS = Array.from({ length: MAX_COMPARE }, (_, i) => `var(--color-series-${i + 1})`);

export function colourOf(index: number): string {
  return SERIES_COLOURS[index % SERIES_COLOURS.length] ?? SERIES_COLOURS[0]!;
}

export function parseIds(raw: string | null): string[] {
  return [
    ...new Set(
      (raw ?? "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean),
    ),
  ];
}

export function compareHref(ids: string[]): string {
  return `/compare?ids=${ids.join(",")}`;
}

/** Only finished experiments have scores worth comparing. */
export function isComparable(e: Pick<ExperimentSummary, "status">): boolean {
  return e.status === "completed" || e.status === "stopped";
}
